import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { toBlob } from "html-to-image";
import { useSelector } from "react-redux";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
function SquareClassified({ preview }) {
  const componentId = useSelector((state) => state.Head.component_id);
  const [styleObject, setStyleObject] = useState({
    background: "linear-gradient(135deg, #F9F2E8, #FCCFBA, #F9F2E8)",
  });
  const handleDownloadPreview = () => {
    const previewElement = document.querySelector(".download-preview");
    toBlob(previewElement).then(function (blob) {
      saveAs(blob, `${preview.name}.png`);
    });
  };
  useEffect(() => {
    if (preview.background !== "0" || preview.gallery?.background !== "0") {
      switch (preview.background || preview.gallery?.background) {
        case "1":
          setStyleObject({
            background: "linear-gradient(135deg, #F9F2E8, #FCCFBA, #F9F2E8)",
          });
          break;
        case "2":
          setStyleObject({
            background: "linear-gradient(135deg, #F9E6E2, #BAFAC6), #CACAFD",
          });
          break;
        case "3":
          setStyleObject({
            background: "linear-gradient(135deg, #E0F9F6, #FFF4A4, #FEDAC4)",
          });
          break;
        default:
          setStyleObject({
            background: "linear-gradient(135deg, #F9F2E8, #FCCFBA, #F9F2E8)",
          });
          break;
      }
    }
  }, [preview.background, preview.gallery?.background]);
  return (
    <>
      <div className="flex mb-5">
        {componentId === 6 ? (
          <div className="justify-end">
            <sl-icon-button
              library="lucide"
              name="download"
              onClick={handleDownloadPreview}
            ></sl-icon-button>
          </div>
        ) : null}
      </div>
      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />
        <div className="preview-inner">
          <div className="h-full grid grid-rows-5 gap-2 p-2 w-full">
            {/* Top component spanning 2 rows */}
            <div className="row-span-2">
              <div className="grid grid-cols-2 gap-2 h-full">
                {/* Left Column */}
                <div style={styleObject} className="flex flex-col justify-between rounded-md p-2">
                  {preview.img_urls && (
                    <img
                      src={preview.img_urls}
                      className="w-full h-20 rounded-lg object-cover"
                      alt="titleimage"
                    />
                  )}

                  <div className="flex items-start gap-2 mt-2">
                    {preview.logo_urls || preview.gallery?.image ? (
                      <img
                        src={preview.logo_urls || preview.gallery?.image}
                        className="w-6 h-6 rounded-full"
                        alt="logo"
                      />
                    ) : null}
                    <div>
                      <h6 className="text-[10px] mb-0">
                        {preview.brand_name || preview.gallery?.brand_name}
                      </h6>
                      <p className="text-[9px] mb-0">
                        {preview.caption || preview.gallery?.caption}
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-[14px] font-bold">
                      {preview.headline || preview.head_line}
                    </h3>
                    <p className="text-[10px] mb-0">{preview.description}</p>
                  </div>

                  {preview.button_enabled ? <button style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr }} className="px-2 py-1 bg-green-500 rounded-md text-xs"><span className="flex gap-1 items-center">{(preview.btn_type !== '0' || preview.gallery?.btn_type !== '0') ? <SlIcon  name={(preview.btn_type === '1' || preview.gallery?.btn_type === '1')? 'telephone' : 'whatsapp'}></SlIcon>: ''}{preview.button_text}</span></button> : null}
                </div>

                {/* Right Column */}
                <div className="bg-slate-100 rounded-md p-2"></div>
              </div>
            </div>

            {/* Remaining 3 rows */}
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="bg-slate-100 rounded-md"></div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default SquareClassified;
